var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('header',[_vm._v(_vm._s(_vm.title))])]),_c('v-main',[_c('module-list',{attrs:{"modules":_vm.modules}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }